
import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

const Home = () => {
  return (
    <>
      <div className="hero-section text-center text-white py-5">
        <Container>
          <h1 className="display-3">LionShield Private Bank</h1>
          <p className="lead">Discreet, Dedicated, and Driven by Your Success.</p>
          <LinkContainer to="/services">
            <Button variant="primary" size="lg">Our Services</Button>
          </LinkContainer>
        </Container>
      </div>
      <Container className="my-5">
        <Row>
          <Col md={4}>
            <h2>Wealth Management</h2>
            <p>Comprehensive strategies to grow and preserve your wealth for future generations.</p>
          </Col>
          <Col md={4}>
            <h2>Investment Advisory</h2>
            <p>Expert insights and tailored investment solutions to meet your financial goals.</p>
          </Col>
          <Col md={4}>
            <h2>Exclusive Banking</h2>
            <p>Personalized banking services that offer convenience, privacy, and exceptional support.</p>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Home;
